import http from './http';
import {ENUMS} from "../services/enums";

export default {
  all() {
    return http().get(`/v1/webhooks`);
  },
  get(id) {
    return http().get(`/v1/webhooks/${id}`);
  },
  create(data) {
    if (data.data_type === ENUMS.WebhookDataTypeEnum.Contact.value) {
      return http().post(`/v1/webhooks/contact`, data);
    } else {
      return http().post(`/v1/webhooks/lead`, data);
    }
  },
  update(data) {
    if (data.data_type === ENUMS.WebhookDataTypeEnum.Contact.value) {
      return http().put(`/v1/webhooks/${data.id}/contact`, data);
    } else {
      return http().put(`/v1/webhooks/${data.id}/lead`, data);
    }
  },
  updateFieldMaps(id, data) {
    return http().put(`/v1/webhooks/${id}/field-maps`, data);
  },
  delete(id) {
    return http().delete(`/v1/webhooks/${id}`);
  },
}
